// Scroll to Top Button Functionality
(function() {
  'use strict';

  // Wait for DOM to be ready
  function initScrollToTop() {
    const scrollToTopBtn = document.getElementById('scrollToTopBtn');
    
    if (!scrollToTopBtn) return;

    // Show/hide button based on scroll position
    function toggleButtonVisibility() {
      if (window.pageYOffset > 300) {
        scrollToTopBtn.classList.add('show');
      } else {
        scrollToTopBtn.classList.remove('show');
      }
    }

    // Smooth scroll to top
    function scrollToTop(e) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }

    // Event listeners
    window.addEventListener('scroll', toggleButtonVisibility, { passive: true });
    scrollToTopBtn.addEventListener('click', scrollToTop);

    // Initial check
    toggleButtonVisibility();
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollToTop);
  } else {
    initScrollToTop();
  }
})();

